<template>
  <v-dialog v-model="dialogOpen" width="550" persistent>
    <v-card>
      <v-card-title>Edit Tariff Details</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-row>
              <v-col>
                <v-select 
                  label="Tariff" v-model="tariff" :items="tariffSelect"
                  item-text="name" item-value="id" :disabled="updateProductLoading"
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col>
                <v-select 
                  label="Contract Length" v-model="cLength" :items="months"
                  item-text="name" item-value="months" :disabled="tariff.id===undefined||updateProductLoading"
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>

              <v-col>
                <v-select 
                  label="Promo" v-model="promo" :items="promos"
                  item-text="name" item-value="id" :disabled="cLength.months===undefined||updateProductLoading"
                  return-object outlined dense hide-details>
                </v-select>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row>
              <v-col>
                <p><b>Add ons</b></p>
                <template v-for="(addon, i) in addons">
                  <v-card :key="`addons-${i}`" class="mb-3">
                    <v-card-text class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                              <v-checkbox v-model="addon.selected" :readonly="addon.forceEnable" @change="clearSelection(addon)"></v-checkbox>
                              <b>{{addon.header | capitalizeString}}</b>
                            </div>
                            <v-sheet max-width="130">
                              <v-text-field :value="addon.selectedAddon.standard_price|formatCurrency" label="Total" readonly outlined dense hide-details></v-text-field>
                            </v-sheet>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="addon.selectedAddon"
                            label="Option" :items="addon.items"
                            item-text="name" item-value="id" 
                            return-object outlined dense hide-details @change="selectAddon(addon)">
                          </v-select>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>

                <template v-for="(addon, i) in uncatAddons">
                  <v-card :key="`uncat-${i}`" class="mb-3">
                    <v-card-text class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                              <v-checkbox v-model="addon.selected"></v-checkbox>
                              <b>{{addon.name | capitalizeString}}</b>
                            </div>
                            <v-sheet max-width="130">
                              <v-text-field :value="addon.standard_price|formatCurrency" label="Total" readonly outlined dense hide-details></v-text-field>
                            </v-sheet>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-row>
              <v-col>
                <p><b>Line Features</b></p>
                <template v-for="(addon, i) in lineFeatures">
                  <v-card :key="`line-features-${i}`" class="mb-3">
                    <v-card-text class="py-0">
                      <v-row no-gutters>
                        <v-col cols="12">
                          <div class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                              <v-checkbox v-model="addon.selected"></v-checkbox>
                              <b>{{addon.name | capitalizeString}}</b>
                            </div>
                            <v-sheet max-width="130">
                              <v-text-field :value="addon.standard_price|formatCurrency" label="Total" readonly outlined dense hide-details></v-text-field>
                            </v-sheet>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </template>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-row class="mb-n4">
          <v-col><p>Exc VAT <b>{{getCalcTotals.totals.exvat | formatCurrency}}</b></p></v-col>
          <v-col><p class="text-center">VAT <b>{{getCalcTotals.totals.vat | formatCurrency}}</b></p></v-col>
          <v-col><p class="text-right">Total <b>{{getCalcTotals.totals.total | formatCurrency}}</b></p></v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small :loading="updateProductLoading" :disabled="updateProductLoading" @click="submit(getFormSelected)">SAVE</v-btn>
        <v-btn color="primary" small outlined :disabled="updateProductLoading" @click="close">CANCEL</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapState,mapActions,mapGetters } from "vuex";

  export default {
    props: ['dialogOpen'],

    data() {
      return {
        newline: false,
        tariff: {},
        cLength: {},
        promo: {},
        months: [],
        promos: [],
        addons: {},
        uncatAddons: [],
        lineFeatures: [],
        defaultAddons: {
          care_level: { name: "Care Level 1", selected: true, forceEnable: false },
          bonline_care: { name: "Fraud Protection", selected: true, forceEnable: true },
        }
      }
    },

    watch: {
      dialogOpen(open){
        if(open){
          this.setupAddons();
          this.uncatAddonsSetup();
          this.lineFeaturesSetup();

          this.tariff = this.getTelcoTariffByID;
          this.months = this.tariff.months;
          this.promos = this.tariff.promos;

          let m = this.getCurrentProduct.contract_length_months;
          this.cLength = {months:m,name:(m===1)?`Month to month`:`${m} Months`};
          this.promo = this.getTelcoPromoByID;
        }
      },

      tariff(tariff) {
        if(tariff.id!==undefined){
          this.months = tariff.months;
          if(tariff.id!==this.getTelcoTariffByID.id){
            this.cLength = {};
            this.promo = {};
          }
        }
      },

      cLength(length) {
        if(length.months!==undefined){
          this.promos = this.tariff.promos;
          if(this.promos!==undefined){
            this.promos.unshift({name: 'No Promo',id:""});
          }
          if(this.cLength.months!==this.getCurrentProduct.contract_length_months){
            this.promo = {};
          }
        }
      },
    },

    computed: {
      ...mapState('productTelco',['updateProductLoading']),
      ...mapGetters('productTelco',['getCurrentProduct','getTelcoTariffs','getCurrentProductAddons','getTelcoAddons','getTelcoTariffByID','getTelcoPromoByID','getTelcoAddonsByID','getTelcoAddonsByName']),

      isAddonInProduct() {
        return (id) => this.getCurrentProduct.addons.some(addon => addon.addon_id == id);
      },

      isTariffInProduct() {
        return (id) => this.getCurrentProduct.tariff_id == id;
      },

      tariffSelect() {
        const tariffMap = this.getTelcoTariffs.reduce((acc, obj) => {
          if(obj.available){
            if((obj.category || (obj.category && this.isTariffInProduct(obj.id)))) {
              if(!acc.hasOwnProperty(obj.category)) {
                acc[obj.category] = [];
                acc[obj.category].push(obj);
              } else {
                acc[obj.category].push(obj);
              }
            } else {
              acc["Other"] = [];
              acc["Other"].push(obj);
            }
          }
          return acc;
        }, {});
        
        return Object.entries(tariffMap).reduce((acc, [key, value]) => {
          const header = { header: key };
          const divider = { divider: true };
          const group = [header, ...value, divider];
          acc.push(...group);
          return acc;
        }, []);
      },

      getFormSelected() {
        let selectedAddons = [];
        let selectedUncatAddons = [];
        let selectedLineFeatures = [];

        Object.values(this.addons).forEach(addon => {
          if(addon.selected) {
            selectedAddons.push({ addon_id: addon.selectedAddon.id });
          }
        });

        this.uncatAddons.forEach(addon => {
          if(addon.selected) {
            selectedUncatAddons.push({ addon_id: addon.id });
          }
        });

        this.lineFeatures.forEach(addon => {
          if(addon.selected) {
            selectedLineFeatures.push({ addon_id: addon.id });
          }
        });
    
        return {
          tariff_id: (this.tariff && this.tariff.id) ? this.tariff.id : null,
          contract_length_months: (this.cLength && this.cLength.months) ? this.cLength.months : null,
          promo_id: (this.promo && this.promo.id) ? this.promo.id : null,
          addons: [...selectedAddons, ...selectedUncatAddons, ...selectedLineFeatures],
        }  
      },

      getCalcTotals() {
        let tariffPrice = (this.promo.price===undefined&&this.tariff.price===undefined)?0:(this.promo.price!==undefined)?parseFloat(this.promo.price):parseFloat(this.tariff.price);
        let tariff = { 
          exvat: tariffPrice, 
          vat: tariffPrice * parseFloat(this.$vatAmount),
          total: tariffPrice * parseFloat(this.$vatAmount + 1)
        };

        let addons = Object.values(this.addons).reduce((acc, obj) => {
          if(obj.selected && Object.keys(obj.selectedAddon).length > 0) {
            acc.exvat += parseFloat(obj.selectedAddon.standard_price);
            acc.vat = acc.exvat * parseFloat(this.$vatAmount);
            acc.total = acc.exvat * parseFloat(this.$vatAmount + 1);
          }
          return acc;
        }, { total: 0.00, exvat: 0.00, vat: 0.00 });
        
        let uncatAddons = this.uncatAddons.reduce((acc, obj) => {
          if(obj.selected) {
            acc.exvat += parseFloat(obj.standard_price);
            acc.vat = acc.exvat * parseFloat(this.$vatAmount);
            acc.total = acc.exvat * parseFloat(this.$vatAmount + 1);
          }
          return acc;
        }, { total: 0.00, exvat: 0.00, vat: 0.00 });

        let lineFeatures = this.lineFeatures.reduce((acc, obj)=>{
          if(obj.selected) {
            acc.exvat += parseFloat(obj.standard_price);
            acc.vat = acc.exvat * parseFloat(this.$vatAmount);
            acc.total = acc.exvat * parseFloat(this.$vatAmount + 1);
          }
          return acc;
        },{ total: 0.00, exvat: 0.00, vat: 0.00 });

        let totals = {
          exvat: lineFeatures.exvat + uncatAddons.exvat + tariff.exvat + addons.exvat,
          vat: lineFeatures.vat + uncatAddons.vat + tariff.vat + addons.vat,
          total: lineFeatures.total + uncatAddons.total + tariff.total + addons.total
        };

        return {
          addons,
          lineFeatures,
          uncatAddons,
          tariff,
          totals
        }
      }
    },

    methods: {
      ...mapActions('productTelco',['updateProduct']),

      selectAddon(selectedAddon) {
        Object.values(this.addons).forEach(addon => {
          if(selectedAddon.header === addon.header && !addon.selected) {
            addon.selected = true;
          }
        });
      },

      clearSelection(selectedAddon) {
        if(!selectedAddon.selected) {
          Object.values(this.addons).forEach(addon => {
            if(selectedAddon.header === addon.header) {
              addon.selectedAddon = {};
            }
          });
        }
      },

      setupAddons() {
        this.getTelcoAddons.forEach(addon => {
          if((addon.display_group && addon.available) || (addon.display_group && this.isAddonInProduct(addon.id))) {
            if(!this.addons.hasOwnProperty(addon.display_group)) {
              let addonObj = {};
              let forceEnable = false;
              let selected = false;
              if(this.defaultAddons[addon.display_group]){
                addonObj = this.getTelcoAddonsByName(this.defaultAddons[addon.display_group].name);
                forceEnable = this.defaultAddons[addon.display_group].forceEnable;
                selected = this.defaultAddons[addon.display_group].selected;
              }
              this.$set(this.addons, addon.display_group, { 
                header: this.formatItemHeader(addon.display_group),
                selected: selected,
                forceEnable: forceEnable,
                selectedAddon: addonObj,
                items: []
              });
            }
            this.addons[addon.display_group].items.push(addon);
          }
        });

        this.getCurrentProduct.addons.forEach(addon => {
          let addonObj = this.getTelcoAddonsByID(addon.addon_id);
          if(addonObj.display_group) {
            this.addons[addonObj.display_group].selectedAddon = addonObj;
            this.addons[addonObj.display_group].selected = true;
          }
        });
      },

      uncatAddonsSetup() {
        this.getTelcoAddons.forEach(addon => {
          if((!addon.category && !addon.display_group && addon.available) || (!addon.category && !addon.display_group && this.isAddonInProduct(addon.id))) {
            this.$set(addon, 'selected', false);
            this.uncatAddons.push(addon);
          }
        });

        this.getCurrentProduct.addons.forEach(e =>{
          this.uncatAddons.forEach(addon => {
            if(e.addon_id === addon.id) {
              this.$set(addon, 'selected', true);
            }
          });
        });
      },

      lineFeaturesSetup() {
        this.getTelcoAddons.forEach(addon => {
          if((addon.category === "cnf_service" && addon.available) || (addon.category === "cnf_service" && this.isAddonInProduct(addon.id))) {
            this.$set(addon, 'selected', false);
            this.lineFeatures.push(addon);
          }
        });

        this.getCurrentProduct.addons.forEach(e =>{
          this.lineFeatures.forEach(addon => {
            if(e.addon_id === addon.id) {
              this.$set(addon, 'selected', true);
            }
          });
        });
      },

      formatItemHeader(val) {
        if(!val) return val;
        return val.split('_').map(e=>e.toLowerCase()).join(" ");
      },

      async submit({ tariff_id, contract_length_months, promo_id, addons, new_line }) {
        let data = {
          updateData: { tariff_id, contract_length_months, promo_id, addons },
          success: 'Tariff details updated successfully!',
        };
        let success = await this.updateProduct(data);
        if(success){
          this.close();
          window.location.reload();
        }
      },

      reset() {
        this.addons = {};
        this.uncatAddons = [];
        this.lineFeatures = [];
        this.tariff = {};
        this.cLength = {};
        this.promo = {};
        this.months = [];
      },

      close() {
        this.reset();
        this.$emit('close-dialog');
      },
    },
  }
</script>

<style lang="scss" scoped></style>
